import { createContext } from 'react';
import initialCatalogState from './initialCatalogState';

const CatalogContext = createContext(initialCatalogState);

export default CatalogContext;
